/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicDetailsResponseDto
 */
export interface PublicDetailsResponseDto {
    /**
     * Any additional credential details. Usually it is credentials cesr
     * @type {string}
     * @memberof PublicDetailsResponseDto
     */
    details?: string;
}

/**
 * Check if a given object implements the PublicDetailsResponseDto interface.
 */
export function instanceOfPublicDetailsResponseDto(value: object): boolean {
    return true;
}

export function PublicDetailsResponseDtoFromJSON(json: any): PublicDetailsResponseDto {
    return PublicDetailsResponseDtoFromJSONTyped(json, false);
}

export function PublicDetailsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicDetailsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'details': json['details'] == null ? undefined : json['details'],
    };
}

export function PublicDetailsResponseDtoToJSON(value?: PublicDetailsResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'details': value['details'],
    };
}

